import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function allProduct() {
	return client.get('/tunnel/api/public/product/data');
}

function recomendedProduct() {
	return client.get('/tunnel/api/public/product/data_recommended');
}

function detailProduct(code) {
	return client.get('/tunnel/api/public/product/detail', {
		params: {
			code: code
		}
	});
}
export default {
	allProduct,
	detailProduct,
	recomendedProduct
};
